// Sniffer (M19-adjacent). PURE (ENG-1). The ancient mob — hatched from an
// archaeology sniffer egg — snuffles over diggable ground and, now and then,
// unearths a torchflower seed. These are the pure dig rules the host drives.
import { SNIFFER } from '../config';

const DIGGABLE = new Set(['grass_block', 'dirt', 'coarse_dirt', 'podzol', 'rooted_dirt', 'moss_block']);

/** Whether a sniffer can dig into this ground block. */
export function snifferDiggableGround(block: string): boolean {
  return DIGGABLE.has(block);
}

/** Ticks between a sniffer's dig attempts. */
export function snifferDigInterval(): number {
  return SNIFFER.DIG_INTERVAL;
}

/** On a dig attempt over diggable ground, a sniffer unearths a seed at these odds. */
export function snifferDigsSeed(roll: number): boolean {
  return roll < SNIFFER.DIG_CHANCE;
}

/** The seed a sniffer unearths — torchflower seeds or a pitcher pod (roll < 0.5 =
 *  torchflower). Defaults to torchflower seeds. */
export function snifferSeed(roll = 0): string {
  return roll < 0.5 ? 'torchflower_seeds' : 'pitcher_pod';
}
